// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__38gWK","savePackageButton":"ClientWallet_savePackageButton__3ZFVs"};